
    export const formatFax = (fax) => {
        if (!fax) return "";
        const cleaned = fax.replace(/\D/g, "");     // remove non-numeric
        if (cleaned.length !== 10) return fax;      // return original if invalid

        return cleaned.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
    };